import type { ListSubheaderProps as MuiListSubheaderProps } from '@mui/material';
import { ListSubheader as MuiListSubheader } from '@mui/material';

export type ListSubheaderProps = MuiListSubheaderProps;

/** ListSubheader component. Based on MUI ListSubheader: https://mui.com/material-ui/api/list/ */
export const ListSubheader = (props: ListSubheaderProps) => (
  <MuiListSubheader {...props} data-testid="list-subheader" />
);
